import ReactDOM from "react-dom/client";
import Root from "./Root";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Root />
);
